import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { mergeCssModules } from '@emoney/kyber-helpers';
import classNames$1 from 'classnames';
import React__default, { forwardRef } from 'react';
import Button$1 from '../../Button/Button.js';
import '../../Button/index.js';
import defaultCssModule from './less/base-popover.module.less.js';

var BasePopover = /*#__PURE__*/forwardRef(function (_ref, _ref2) {
  var id = _ref.id,
      children = _ref.children,
      className = _ref.className,
      labeledby = _ref.labeledby,
      style = _ref.style,
      containerStyle = _ref.containerStyle,
      onRequestClose = _ref.onRequestClose,
      cssModuleProp = _ref.cssModule,
      saveRef = _ref.saveRef,
      onKeyDown = _ref.onKeyDown,
      arrowClasses = _ref.arrowClasses,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      restProps = _objectWithoutPropertiesLoose(_ref, ["id", "children", "className", "labeledby", "style", "containerStyle", "onRequestClose", "cssModule", "saveRef", "onKeyDown", "arrowClasses", "onFocus", "onBlur"]);

  var cssModule = mergeCssModules(cssModuleProp, defaultCssModule);
  var containerClasses = classNames$1(cssModule.container, className);
  var popoverClasses = classNames$1(cssModule.popover, cssModule.fade, cssModule.in);
  return /*#__PURE__*/React__default.createElement("div", {
    className: containerClasses,
    ref: function ref(reference) {
      saveRef(reference);

      if (_ref2) {
        _ref2(reference);
      }
    },
    style: containerStyle,
    onKeyDown: onKeyDown,
    tabIndex: "-1",
    role: "presentation",
    id: id + "-wrapper",
    onFocus: onFocus,
    onBlur: onBlur
  }, /*#__PURE__*/React__default.createElement("div", {
    id: id + "-arrow",
    className: classNames$1(cssModule['arrow'], arrowClasses)
  }), /*#__PURE__*/React__default.createElement("div", _extends({}, restProps, {
    id: id,
    "aria-labelledby": labeledby,
    className: popoverClasses,
    role: "dialog",
    style: style
  }), children, /*#__PURE__*/React__default.createElement(Button$1, {
    id: id + "-close-btn",
    className: classNames$1(cssModule['close-btn']),
    link: true,
    onClick: onRequestClose,
    "aria-label": "close popover"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "ei ei-close",
    "aria-hidden": "true"
  }))));
});
BasePopover.defaultProps = {
  saveRef: function saveRef() {},
  onKeyDown: function onKeyDown() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  style: {},
  containerStyle: {}
};
BasePopover.displayName = 'BasePopover';

export default BasePopover;
